import { render, staticRenderFns } from "./crateForecast.vue?vue&type=template&id=71e37e72&scoped=true"
import script from "./crateForecast.vue?vue&type=script&lang=js"
export * from "./crateForecast.vue?vue&type=script&lang=js"
import style0 from "./crateForecast.vue?vue&type=style&index=0&id=71e37e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e37e72",
  null
  
)

export default component.exports